// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { Divider as MuiDivider, Typography } from '@mui/material';
import { Button, IconButton } from 'components/Buttons';
import MBDialog from 'components/Elements/MBDialog';
import MBTextField from 'components/Forms/MBTextField/MBTextField';
import { pxToEm } from 'theme';
import hexToRGBA from 'theme/hexToRGBA';
import palette from 'theme/palette';

interface MaterialImageProps {
  width: number;
  height: number;
}

interface ContainedCartButtonProps {
  isAddedToCart?: boolean;
}

interface DialogProps {
  id?: string;
  backdropTopPadding?: number | null;
}

interface EcoTabProps {
  isActive: boolean;
}

export const ErrorIdLabel = styled(Typography)`
  position: absolute;
  left: 24px;
  margin-top: 5px;
`;

export const TextField = styled(MBTextField)`
  height: 56px !important;
  max-height: unset !important;
  margin: 0 !important;

  & > .MuiInput-underline {
    height: 100%;
  }

  input {
    margin-right: 67px;
    overflow: hidden;
  }

  .MuiInput-underline.Mui-focused:after {
    border-color: ${palette.primary.main} !important;
  }
`;

export const InputAddButton = styled(Button)`
  transition: all 0.2s linear;
  position: absolute;
  right: 0;
  bottom: 8px;
  background: ${palette.grey[900]};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: auto !important;
  border: none;

  &:focus: {
    outline: none;
  }

  &:hover: {
    background: ${palette.grey[800]};
  }
`;

export const AddedNotificationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 5px;
`;

export const TitleLabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-top: 5px;
  margin-bottom: 15px;
`;

export const Label = styled.div`
  display: flex;
  border-radius: 12px;
  background: ${palette.primary.main};
  color: ${palette.common.white};
  padding: 4px 8px;
  line-height: 1;
  font-size: 12px;
  margin-left: 4px;
`;

export const MaterialImage = styled.img<MaterialImageProps>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  border-radius: 12px;
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  left: calc(100% - 40px);
  top: 10px;
`;

export const Divider = styled(MuiDivider)`
  margin-top: 16px;
  background-color: ${palette.grey[50]};
  border-color: ${palette.grey[50]};
  margin-bottom: 1em;
`;

export const RecommendedItemsContainer = styled.div`
  width: 100%;
  pointer-events: all;
`;

export const MaterialInfo = styled.div`
  color: ${palette.grey['A400']};
  overflow: hidden;
`;

export const ContainedCartButton = styled(IconButton, {
  shouldForwardProp: (prop) => !['isAddedToCart'].includes(String(prop)),
})<ContainedCartButtonProps>`
  z-index: 2;
  width: 44px;
  height: 44px;
  pointer-events: ${(props) => (props?.isAddedToCart ? 'none' : 'auto')};

  &:focus {
    background-color: ${({ theme, isAddedToCart }) =>
      isAddedToCart
        ? theme.palette.primary.main
        : theme.palette.secondary?.main};
  }
`;

export const EcoTabs = styled.div`
  display: none;
  justify-content: center;
  width: 100%;
  margin-top: 32px;
  align-items: center;
  position: relative;
`;

export const EcoTab = styled.div<EcoTabProps>`
  background-color: ${palette.green.main};
  opacity: ${({ isActive }) => (isActive ? 1 : 0.2)};
  height: 4px;
  border-radius: 4px;
  width: 33%;
  margin: 0 2px;
`;

export const EcoCaptionBox = styled.div`
  display: none;
  color: ${palette.green.main};
  margin-top: 0.6em;
`;

export const SustainabilityIcon = styled(IconButton)`
  background-color: ${hexToRGBA(palette.green.main, 0.2)};
`;

export const Dialog = styled(MBDialog)<DialogProps>`
  padding: 0 !important;

  & > div {
    box-shadow: none !important;
    max-height: unset !important;
    position: absolute !important;
    top: 0px !important;
    right: 0px !important;
    height: initial !important;
    pointer-events: initial !important;
    padding-right: 32px !important;
    padding-top: ${({ backdropTopPadding }) => backdropTopPadding}px !important;
    & > .MuiPaper-root.MuiPaper-root {
      padding: 0;
      box-shadow: none;
      background: transparent;
    }
  }
`;

export const TopBannerContainer = styled.div`
  width: 100%;
  padding: ${pxToEm(20)};
  background-color: ${({ theme }) => theme.palette.common.white};
  box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  margin-bottom: 4px;
`;

export const MaterialImageLinkWrapper = styled.a`
  height: 88px;
  aspect-ratio: 1/1;
`;

export const SmallerMaterialImageLinkWrapper = styled.a`
  width: 56px;
  height: 56px;
`;

export const SpanLabel = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.common.white};
  padding: 0 22px;
  width: fit-content;
  border-radius: 25px;
  font-size: 12px;
`;
